import { Label } from '@radix-ui/react-label';
import { Avatar, AvatarFallback } from '~/components/ui/avatar';
import { Button } from '~/components/ui/button';
import { LogOut } from 'lucide-react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/components/ui/popover';
import { useGlobalState } from '~/context/GlobalStateContext';

export const Profile = () => {
  const {
    generalState: { user },
    signOut,
  } = useGlobalState();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Avatar className='w-9 h-9'>
          <AvatarFallback>
            {user?.email?.split('')[0].toUpperCase()}
          </AvatarFallback>
        </Avatar>
      </PopoverTrigger>
      <PopoverContent className='w-fit'>
        <div className='grid gap-4'>
          <div className='space-y-2'>
            <p className='text-muted-foreground text-sm'>{user?.email}</p>
          </div>
          <div className='space-y-2'>
            <Button
              variant='outline'
              className='ms-auto w-full'
              onClick={signOut}
            >
              <LogOut /> Logout
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
